module.exports = __webpack_public_path__ + "fonts/a81114e.otf";